/**
 * Returns true for UUID / long hex strings that are better rendered monospace.
 */
export const looksLikeId = (value: string): boolean =>
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(
    value.trim()
  ) || /^[0-9a-f]{20,}$/i.test(value.trim());